module.exports = __webpack_public_path__ + "img/43.9a1af17b.png";